module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAJCAYAAAARml2dAAAAZElEQVQYV3XOMQqDUBRE0XsXmDKkE8F1BOIO3Iu9jZXb0ELEBaQRfnjgh4+YV86ZgSd/zpTSDNTqUHYC0hm06idjCZGNwEtdrxC4AY87CKyusAON2pcwAU91iUnAF+iAt3rkr36G8yuWHOb+ugAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taskPlan/rightArrow.png
// module id = dY11
// module chunks = 2